import { ICellStyles, ICommonTable } from '../table.component.tsx';
import { GridCellParams } from '@mui/x-data-grid/models/params/gridCellParams';
import { MutableRefObject } from 'react';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';

export const useSmartVerticalDividers = (viewCells: ICommonTable['viewCells']) => {
  const defineColor = (styles: ICellStyles[], classArr: Array<string>): string => {
    return (
      styles.reduce<string | undefined>((acc, style) => {
        if (!acc && classArr.includes(style.className)) {
          acc = (style.cellStyles as any)?.backgroundColor;
        }
        return acc;
      }, '') || ''
    );
  };

  return (
    params: GridCellParams<any, any, any>,
    apiRef: MutableRefObject<GridApiPremium>,
  ): string => {
    let withoutDivider: string = '';
    if (params.id !== 'auto-generated-group-footer-root') {
      const visibleColumns = apiRef?.current?.getVisibleColumns?.();
      const orderColumnNames = visibleColumns?.map(({ field }) => field);
      const { id, field } = params;

      // last visible column doesn't need right divider
      if (orderColumnNames?.[orderColumnNames.length - 1] === field) {
        return 'withoutDivider';
      }

      // columns with different colors don't need divider between
      let colorCurrCell: string = '';
      let colorNextCell: string = '';

      if (viewCells?.actions) {
        const { actions } = viewCells;
        const classes = actions[field]?.(params) || '';
        const classArr = classes?.split(' ');

        colorCurrCell = defineColor(viewCells.styles, classArr);

        const index = orderColumnNames?.findIndex((el) => el === field);
        const nextColumnName = orderColumnNames?.[index + 1];
        const nextCellParams = nextColumnName
          ? apiRef?.current?.getCellParams(id, nextColumnName)
          : null;
        const fullNextCellParams = nextCellParams
          ? {
              ...params,
              ...nextCellParams,
            }
          : null;
        if (fullNextCellParams && nextColumnName) {
          const nextCellClasses = actions[nextColumnName]?.(fullNextCellParams) || '';
          const nextCellClassesArr = nextCellClasses?.split(' ');
          colorNextCell = defineColor(viewCells.styles, nextCellClassesArr);
        }

        switch (true) {
          case colorCurrCell !== colorNextCell:
            withoutDivider = 'withoutDivider';
            break;
        }
      }
    }
    return withoutDivider;
  };
};
